import styled from 'styled-components'

export const SelectContainer = styled.div`
  width: 120px;
  .mdc-select__selected-text {
    min-width: 120px;
  }
  .ui-select {
    background: #000 !important;
    .mdc-select__icon,.mdc-select__dropdown-icon,.mdc-select__selected-text {
      color: #FFF !important;
      align-items:center;
      opacity: 1;
    }
    .rmwc-icon.material-icons.mdc-select__icon {
      font-size:30px;
      margin-bottom:3px;
    }
  }
`